import {CircularProgress, Logo, RiveFetch} from "parts";
import {useTranslation} from "react-i18next";
import {Goals} from "./Goals";
import React from "react";
import {getItem} from "utils";
import {colors} from "../pages/Summarize";

export function GoalTop({children, blur = false}) {
  const {t} = useTranslation('common', {keyPrefix: 'summarize'})

  const
    data = getItem('summarize', {}, window.sessionStorage),
    levels = Object.entries(data.levels || {})

  return (
    <>
      {
        blur &&
        <style>{
`.logo, .blur { filter: blur(4px); user-select: none }`
        }</style>
      }
      <Logo/>

      <h1 className={'blur'}>{t('goals.h1')}</h1>

      <Goals className={'blur'}/>

      <div className={'blur block secondary p-0'}>
        <RiveFetch width={350} height={160}
                   image={'/charisma/static/img/goal-top.png'}
                   src={'charisma_quiz.riv'} module={true}
                   artboard={'illustration-5'} stateMachines={'state-machine'}
        />

        <div className={'row'} style={{padding: 20, justifyContent: 'space-evenly'}}>
          {
            levels.map(([name, value], i) =>
              <div key={name} className='paragraph'>
                <CircularProgress value={value} strokeColor={colors[i]}/>
                {t(`level.${name}`)}
              </div>
            )
          }
        </div>

        {children}
      </div>
    </>
  )
}